<h2>Reason for Vaccine Not Given</h2>

@if (errorMessage) {
  <div class="error-message">
    <app-error-summary [error]="errorMessage" [status]="errorStatus"></app-error-summary>
  </div>
}

@if (!errorMessage) {
  @if (consentRefusal$ | async) {
    <table role="table" class="nhsuk-table-responsive">
      <thead role="rowgroup" class="nhsuk-table__head">
        <tr role="row">
          <th role="columnheader" class="" scope="col">Date of consent</th>
          <th role="columnheader" class="" scope="col">Antigen</th>
          <th role="columnheader" class="" scope="col">Consent</th>
          <th role="columnheader" class="" scope="col">Reason</th>
        </tr>
      </thead>
      <tbody class="nhsuk-table__body">
        @for (consent of consentRefusalData; track consent) {
          <tr role="row" class="nhsuk-table__row">
            @if (consent.consent && consent.consent === 'N') {
              <td role="cell" class="nhsuk-table__cell">
                <span class="nhsuk-table-responsive__heading" aria-hidden="true">Consent date </span
                >{{ consent.consentDate | date: 'dd/MM/yyyy' }}
              </td>
              <td role="cell" class="nhsuk-table__cell">
                <span class="nhsuk-table-responsive__heading" aria-hidden="true">Vaccine </span>{{ consent.vaccine }}
              </td>
              <td role="cell" class="nhsuk-table__cell">
                <div class="flex gap-8 wrap flex-start">
                  <span class="nhsuk-table-responsive__heading" aria-hidden="true">Consent </span>
                  {{ consent.consent }}
                </div>
              </td>
              <td role="cell" class="nhsuk-table__cell">
                <span class="nhsuk-table-responsive__heading" aria-hidden="true">Reason </span
                >{{ consent.reasonForNegativeConsent }}
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  }
} @else {
  <app-loading-spinner />
}
